var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.87 133.65H69.31l-44.43 88.1a42.165 42.165 0 00-5.14 20.16v197.32c0 42.19 34.2 76.39 76.39 76.39h176.36c42.19 0 76.39-34.2 76.39-76.39V242.15c0-7.19-1.84-14.27-5.35-20.55l-46.66-87.95z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.96 7.89h-147c-39.682 0-71.85 32.169-71.85 71.85v25.47c0 39.682 32.168 71.85 71.85 71.85h147c39.682 0 71.85-32.168 71.85-71.85V79.74c0-39.681-32.168-71.85-71.85-71.85z",
    fill: "#FD934F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.06 2.61H94.44c-32.883 0-59.54 26.655-59.54 59.535 0 32.88 26.657 59.535 59.54 59.535h171.62c32.883 0 59.54-26.655 59.54-59.535 0-32.88-26.657-59.535-59.54-59.535z",
    fill: "#FED425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.16 424.16H66.47c-25.808 0-46.73 20.922-46.73 46.73 0 25.808 20.922 46.73 46.73 46.73h235.69c25.808 0 46.73-20.922 46.73-46.73 0-25.808-20.922-46.73-46.73-46.73z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 27.47,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.89 52.63h-80.35c-7.097 0-12.85 5.753-12.85 12.85v1.44c0 7.097 5.753 12.85 12.85 12.85h80.35c7.097 0 12.85-5.753 12.85-12.85v-1.44c0-7.097-5.753-12.85-12.85-12.85z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.08 411.57H90.35c-16.105 0-29.16 13.055-29.16 29.16v15.82c0 16.104 13.055 29.16 29.16 29.16h188.73c16.105 0 29.16-13.056 29.16-29.16v-15.82c0-16.105-13.055-29.16-29.16-29.16z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.27 206v237.65c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V207.17L147.28 206h-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.47 226.71c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.67 374.09c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M223.67 338.81c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M223.67 303.54c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M223.67 268.85c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M223.67 234.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M223.67 409.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7 206v237.65c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V207.17L62.71 206h-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.9 226.71c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.09 374.09c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M139.09 338.81c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M139.09 303.54c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M139.09 268.85c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M139.09 234.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M139.09 409.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.8 206v237.65c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V207.17L229.81 206h-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268 226.71c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M306.2 374.09c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M306.2 338.81c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M306.2 303.54c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M306.2 268.85c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M306.2 234.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M306.2 409.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.99 400.92c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2zM146.11 278.21c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2zM284.35 350.23c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2zM223.67 467.56c21.097 0 38.2-17.103 38.2-38.2s-17.103-38.2-38.2-38.2-38.2 17.103-38.2 38.2 17.103 38.2 38.2 38.2z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 15.85,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M293.28 266.55v-24.4c0-7.19-1.84-14.27-5.35-20.55l-9-16.97M293.28 395.48v-81.34",
    stroke: "#FBFDFE",
    strokeWidth: 21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar4);
export default ForwardRef;